/**
 * Utils file for general modifications.
 */

import { removeWhiteSpaces } from "./format";

/**
 * toggleItem
 * If item is already in array, remove it.
 * If item is not in array already, add it.
 * @type string[]
 */
export const toggleItem = (previous: string[], item: string) =>
    previous?.includes(item)
        ? // remove
          previous?.filter((previousItem) => previousItem !== item)
        : // add
          [...(previous || []), item];

/**
 * Remove grouping by parent - children, from categories.
 * @type any[]
 */
export const flattenCategories = (
    categories: { uuid?: string; name?: string; children?: { uuid?: string; name?: string }[] }[]
) => {
    const flattenedCategories: { uuid?: string; name?: string }[] = [];

    categories.forEach((item) => {
        flattenedCategories.push(item);
        item.children?.forEach((child) => flattenedCategories.push(child));
    });

    // sort by name
    flattenedCategories.sort((a, b) => {
        if (!a?.name || !b?.name) return 0;
        return a.name.localeCompare(b.name);
    });

    return flattenedCategories;
};

export const isEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

export const isPhone = (value: string) => /^\+?[0-9\s\-()]{7,}$/.test(value);

export const isPtMobilePhone = (value: string) => {
    const normalized = removeWhiteSpaces(value);
    return /^(?:\+351|00351|351)?9\d{8}$/.test(normalized);
};
